import { render, staticRenderFns } from "./StockOnHand.vue?vue&type=template&id=08072f0d"
import script from "./StockOnHand.vue?vue&type=script&lang=js"
export * from "./StockOnHand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports